// export const SchoolDisplay = {
//     primary:{
//         name: 'Primary',
//         subject:'subject',
//         levels:'Class'
//     },
//     secondary:{
//         name: 'Secondary',
//     },
//     high:{
//         name: 'High',
//         subject:'course',
//     },
// }

import { IUser, UserRole } from 'app/interfaces/user.interface';
import { LocalStore } from './localstore.utils';

export const ActiveUser = () => LocalStore.getItem('user', {}) as IUser;
export const isAdmin = () => ActiveUser().role?.name?.toUpperCase() === UserRole.admin;
export const isLearner = () => ActiveUser().role?.name?.toUpperCase() === UserRole.learner;
export const isStaff = () => ActiveUser().role?.name?.toUpperCase() === UserRole.staff;
export const hasPermission = (permission: string) => ActiveUser().permissions.includes(permission.toUpperCase());
export const activityParser = (activity: Record<string, any>, subscribedActions: string[] = []) => {
    const activities = [];
    subscribedActions.forEach(action => {
        const actionEventData = activity[action + '_' + ActiveUser().id];
        if (actionEventData) {
            return activities.push({
                action,
                data: activity[action + '_' + ActiveUser().id]?.data,
                time: activity[action + '_' + ActiveUser().id]?.time
            });
        }
    });
    return activities;
};
